/**------------------------------------------------------
 * RxJs Error
 * ----------
 * ...
 */
export class RxJsError {
	// ...
}
